import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingConfigurationCurrencyActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Currency/CurrencyBrowser")
	}

	render() {
		return (
			<Activity 
				name="AccountingConfigurationCurrency"
				RenderedComponent={this.RenderedComponent}
				context="AccountingConfigurationCurrency"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingConfigurationCurrencyActivity)
